import { memo } from 'react';
import logo from '../../assets/images/logo.png';

const Logo = memo(({ 
  size = 'md', 
  className = '',
  onClick,
  rounded = false, // New prop to control rounding
  ...props 
}) => {
  const sizes = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-10 h-10', 
    lg: 'w-16 h-16',
    xl: 'w-24 h-24',
    '2xl': 'w-32 h-32'
  };

  // Choose rounding style based on rounded prop
  const roundingClass = rounded ? 'rounded-full' : 'rounded-lg';
  const baseClasses = `${sizes[size]} ${roundingClass} object-cover`;
  const clickableClasses = onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : '';

  return (
    <img 
      src={logo}
      alt="CreditPesa Loans"
      className={`${baseClasses} ${clickableClasses} ${className}`}
      onClick={onClick}
      loading="lazy"
      {...props}
    />
  );
});

Logo.displayName = 'Logo';

export default Logo;